import {HttpClient} from '@angular/common/http';
import {ToastService} from '../../toast-service';
import {Injectable} from "@angular/core";
import {BatchUpdateRequest} from "../../../model/api/batch-update-request";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../model/api/api-validation";
import {Order} from "../../../model/clearing/order";
import {CrystalclearSupportBackUrl} from "../../config/crystalclear-support-back-url";
import {CommonCrudService} from "../../common/common-crud.service";

@Injectable({
  providedIn: 'root'
})
export class SupportOrderService extends CommonCrudService<Order> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearSupportBackUrl.GET_SUPPORT_ORDER_LIST,
      CrystalclearSupportBackUrl.SAVE_SUPPORT_ORDER,
      CrystalclearSupportBackUrl.DELETE_SUPPORT_ORDER);
  }

  public saveBatch(request: BatchUpdateRequest<Order>): Observable<ApiValidation<any>> {
    return this.post(CrystalclearSupportBackUrl.SAVE_BATCH_SUPPORT_ORDER, request);
  }

}
